
export const LOCALE_CN = 'zh-CN';
export const LOCALE_EN = 'en-US"';

export const LANGUAGE = {
  en: {
    dbb_confirm: 'Confirm',
    dbb_cancel: 'Cancel',
    dbb_input_error: 'Input error, please enter an integer without special characters',
    dbb_input_less_min: 'The maximum value cannot be less than the minimum value',
    dbb_input_more_max: 'The minimum value cannot be greater than the maximum value',
    dbb_input_percent_max: 'Input error, please enter an integer within 100',
    dbb_input_custom_min: 'Min',
    dbb_input_custom_max: 'Max',
    dbb_input_top: 'Top',
  },
  cn: {
    dbb_confirm: '确认',
    dbb_cancel: '取消',
    dbb_input_error: '输入错误，请输入整数，勿带特殊字符',
    dbb_input_less_min: '最大值不能小于最小值',
    dbb_input_more_max: '最小值不能大于最大值',
    dbb_input_percent_max: '输入错误，请输入100以内的整数',
    dbb_input_custom_min: '最小',
    dbb_input_custom_max: '最大',
    dbb_input_top: '前',
  }
};
